<template>
  <CardContent>
    <h2 class="Groove u-spaceBottom04">Joinder Agreement</h2>
    <p>
      Please note that a separate Joinder Agreement is needed for each provider. Please complete and
      sign the attached Aggrement and return via email to
      <a href="mailto:bpp@bmcjax.com">bpp@bmcjax.com</a> or fax (904) 391-5321
    </p>
    <p>
      Your inclusion in <abbr title="Baptist Physician Partner">BPP</abbr> will become effective
      only after approval by the <abbr title="Baptist Physician Partner">BPP</abbr> Board of
      Managers. If approval is effective <time datetime="2025-04-01"><u>April 1st</u></time> of the
      current year, you will not be elligible for shared savings until the next performance year.
    </p>
    <p>
      <strong>Please note:</strong> Locums and fellows <em>are not accepted</em> into Baptist
      Physician Partners at this time.
    </p>
    <p>
      <a
        class="Button Button--subtle Button--compact"
        href="https://assets.contentstack.io/v3/assets/blt2d8070551210692f/blt3aaee8faf9d60527/655b892081b93ed9e9a1813d/JoinderAgreement638355559156949452184387e4-9d75-45db-aa61-10c130fe5157.pdf"
        target="_blank"
        download=""
      >
        <span>Download Joinder Agreement</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          aria-hidden="true"
          class="Icon u-textGrow1 u-spaceLeft06"
          focusable="false"
          role="presentation"
        >
          <path
            d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </a>
    </p>
    <hr />
    <!-- Agreement Confirmation -->
    <div>
      <label class="Toggle Toggle--checkbox u-textBlackAlt">
        <input class="Toggle-input" type="checkbox" v-model="formStore.isFormAccurate" />
        <span class="Toggle-indicator"></span>
        <span class="Toggle-label">
          The information provided in this application is accurate and I have read and understood
          the Joinder Agreement.
        </span>
      </label>
    </div>
  </CardContent>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useFormStore } from '../../stores/formStore'
import CardContent from '../CardContent.vue'

const formStore = useFormStore()

// Define emit for validity changes
const emit = defineEmits(['validity-changed'])

// Step 6 validation - based on the agreement checkbox
const isStep6Valid = computed(() => {
  return formStore.isFormAccurate
})

// Watch for validation changes and emit to parent
watch(
  isStep6Valid,
  (newValid) => {
    formStore.setStepValidation(6, newValid)
    emit('validity-changed', newValid)
  },
  { immediate: true },
)
</script>

<style scoped>
hr {
  height: 1px;
}
</style>
